import { useTheme } from "../../../context/ThemeProvider";
import { useCallChrome } from "./CallChromeContext";

export default function CallHeader() {
  const { theme } = useTheme();
  const { headerVisible, callTypeLabel, logoSrc } = useCallChrome();

  return (
    <div
      className={`relative flex w-full items-center overflow-hidden border-b px-4 backdrop-blur-xl transition-[max-height,min-height,opacity,padding,border-color] duration-500 ease-out sm:px-6 lg:px-10 2xl:px-14 ${
        headerVisible
          ? "max-h-16 min-h-16 opacity-100"
          : "pointer-events-none max-h-0 min-h-0 border-transparent opacity-0"
      } ${
        theme === "dark"
          ? "border-white/5 bg-black/40"
          : "border-black/5 bg-white/60"
      }`}
      aria-hidden={!headerVisible}
    >
      <div className="flex min-h-16 items-center gap-3">
        {logoSrc && (
          <img
            src={logoSrc}
            className="h-10 w-auto max-w-[9rem] object-contain sm:h-12"
            alt=""
          />
        )}
      </div>

      <div className="pointer-events-none absolute inset-x-0 top-1/2 flex -translate-y-1/2 justify-center">
        <div
          className={`pointer-events-auto hidden items-center gap-2 rounded-full border px-4 py-1.5 text-sm sm:flex ${
            theme === "dark"
              ? "border-white/10 bg-white/5 text-white/80"
              : "border-black/10 bg-black/5 text-darkText/80"
          }`}
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
          </span>
          <span className="font-medium">{callTypeLabel}</span>
        </div>
      </div>
    </div>
  );
}
